// extracted by mini-css-extract-plugin
export default {"hideOnSmall":"GlobalCreateMenu-module__hideOnSmall--ord0Y"};